<template>
  <div>
    <v-card height="80vh" class="mt-5">
      <v-row class="ml-5 mr-5">
        <v-col cols="1">
          <v-text-field
            label="Id_evento"
            type="text"
            required
            v-model="id_evento"
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            label="Descrizione *"
            type="text"
            required
            v-model="descrizione"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="data_inizio"
            hide-details
            type="date"
            label="Data inizio *"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-autocomplete
            background-color="#ffffff"
            hide-details
            :items="ore_inizio"
            label="Ora inizio *"
            v-model="ora_inizio"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="data_fine"
            hide-details
            type="date"
            label="Data fine"
          >
          </v-text-field
        ></v-col>
        <v-col cols="1">
          <v-text-field
            v-model="intervallo"
            hide-details
            type="number"
            label="Intervallo *"
          >
          </v-text-field
        ></v-col>
        <v-col cols="2">
          <v-autocomplete
            background-color="#ffffff"
            hide-details
            :items="lista_unita_misura"
            label="Unità *"
            :item-text="(e) => e.descrizione"
            item-value="id_tabella"
            v-model="misura"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ml-5" align="center" justify="center">
        <v-col cols="2"
          ><p>Invio abilitato nei giorni: *</p>
          <v-btn @click="giorni_scelti = []" small
            ><v-icon color="primary">mdi-broom</v-icon></v-btn
          ><v-btn @click="giorni_scelti = [1, 2, 3, 4, 5, 6, 7]" small
            ><v-icon color="primary">mdi-check-all</v-icon></v-btn
          ></v-col
        >
        <v-col cols="10">
          <v-radio-group row v-model="giorni_scelti" multiple>
            <v-radio
              v-for="(item, index) in giorni"
              :key="index"
              :label="`${item.nome}`"
              :value="item.id"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="ml-5" align="center" justify="center">
        <v-col cols="2"
          ><p>Invio abilitato nelle ore: *</p>
          <v-btn @click="ore_scelte = []" small
            ><v-icon color="primary">mdi-broom</v-icon></v-btn
          ><v-btn
            @click="
              ore_scelte = [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 23,
              ]
            "
            small
            ><v-icon color="primary">mdi-check-all</v-icon></v-btn
          ></v-col
        >
        <v-col cols="10">
          <v-radio-group row v-model="ore_scelte" multiple>
            <v-radio
              v-for="(item, index) in ore"
              :key="index"
              :label="`${item}`"
              :value="index"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="ml-5">
        <v-col cols="3">
          <v-switch
            v-model="festivita"
            :false-value="0"
            :true-value="1"
            :label="'Invio abilitato nei giorni festivi'"
          ></v-switch>
        </v-col>
        <v-col cols="3">
          <v-switch
            v-model="if_db_esterno"
            :false-value="0"
            :true-value="1"
            :label="'Database esterno'"
          ></v-switch>
        </v-col>
        <v-col cols="5" v-if="if_db_esterno == 1">
          <v-autocomplete
            background-color="#ffffff"
            hide-details
            :items="lista_db_esterni"
            :item-text="(e) => e.descrizione"
            item-value="id"
            return-object
            label=""
            v-model="db_esterno"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ml-5 mb-5">
        <v-col cols="3">
          <v-autocomplete
            background-color="#ffffff"
            hide-details
            :items="modalita_messaggio"
            label="Messaggio"
            v-model="query_messaggio"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-switch
            v-if="query_messaggio == 'Query libera'"
            v-model="messaggi_multipli"
            :false-value="0"
            :true-value="1"
            :label="'Messaggi multipli'"
          ></v-switch>
        </v-col>
        <v-col cols="3">
          <v-select
              hide-details
              :items="gruppi"
              item-text="des"
              item-value="id_tabella"
              v-model="id_gruppo"
            >
              <template #label>
                <span>Gruppi di eventi     </span>
                <span @click.stop style="min-width: 500px; pointer-events: all">
                  <Modules
                    v-on:dialogModules="gettabelle"
                    tipo="NOTICE_GRUPPO"
                    nome="Gruppi di eventi"
                    setaction="settabella"
                    getaction="gettabella"
                    controller="Global"
                    :filter="'validita = 1'"
                    :dati="[{ des: '' }]"
                  />
                </span>
              </template>
            </v-select>
        </v-col>
      </v-row>
      <v-row class="ml-5 mb-5 mt-0 pt-0">
        <v-col cols="10" class="mt-0 pt-0" v-if="query_messaggio == 'Testo'">
          <v-text-field
            background-color="#ffffff"
            label="Messaggio di testo"
            v-model="mex_testo"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "ImpGenerale",
  components: {  Modules: () => import("@/components/TOOLS/Modules")},
  props: ["nuovo", "selez"],
  data() {
    return {
      // Variabili di supporto
      descrizione: "",
      id_evento: null,
      data_inizio: null,
      ora_inizio: "00:00:00",
      data_fine: null,
      intervallo: null,
      misura: null,
      evento: null,
      id_gruppo: null,
      messaggio: null,
      query_messaggio: "",
      mex_testo: "",
      if_db_esterno: 0,
      db_esterno: null,
      messaggi_multipli: 0,
      festivita: 0,

      // Modali

      // Array
      modalita_messaggio: ["Query libera", "Testo"],
      lista_query_standard: [],
      lista_unita_misura: [],
      ore: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23,
      ],
      ore_inizio: [
        "00:00:00",
        "01:00:00",
        "02:00:00",
        "03:00:00",
        "04:00:00",
        "05:00:00",
        "06:00:00",
        "07:00:00",
        "08:00:00",
        "09:00:00",
        "10:00:00",
        "11:00:00",
        "12:00:00",
        "13:00:00",
        "14:00:00",
        "15:00:00",
        "16:00:00",
        "17:00:00",
        "18:00:00",
        "19:00:00",
        "20:00:00",
        "21:00:00",
        "22:00:00",
        "23:00:00",
      ],
      giorni: [
        { nome: "Lunedì", id: 1 },
        { nome: "Martedì", id: 2 },
        { nome: "Mercoledì", id: 3 },
        { nome: "Giovedì", id: 4 },
        { nome: "Venerdì", id: 5 },
        { nome: "Sabato", id: 6 },
        { nome: "Domenica", id: 7 },
      ],
      giorni_scelti: [],
      ore_scelte: [],
      // Da popolare poi con la chiamata getDBEsterni
      lista_db_esterni: [],
      gruppi: [],
    };
  },

  methods: {
    formatData(arg) {
      return arg != null && arg != "" ? moment(arg).format("YYYY-MM-DD") : "";
    },

    getDatabase() {
      let request = {
        controller: "Notice",
        method: "POST",
        richiesta: {
          action: "getdatabases",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            this.lista_db_esterni = res.data;
            if (!this.nuovo && this.selez.id_database != null) {
              this.lista_db_esterni.forEach((e) => {
                if (e.id == this.selez.id_database) {
                  this.db_esterno = e;
                }
              });
            }
          }
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
        });
    },

    gettabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "NOTICE_GRUPPO",
          filter: "validita = 1",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.gruppi = res.data ? res.data : [];
        }
      });
    },

    getUnitaMisura() {
      let request = {
        controller: "Notice",
        method: "POST",
        richiesta: {
          action: "getunitamisuratempo",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data != 0) {
          this.lista_unita_misura = res.data;
        } else {
          console.log("Non ci sono query.");
        }
      });
    },
  },

  computed: {},

  watch: {
    if_db_esterno() {
      if (this.if_db_esterno == 0) {
        this.db_esterno = null;
      }
    },
  },

  mounted() {
    if (!this.nuovo) {
      this.id_evento = this.selez.id_evento;
      this.descrizione = this.selez.descrizione;
      this.data_inizio = this.formatData(this.selez.inizio);
      this.data_fine = this.formatData(this.selez.fine);
      this.intervallo = this.selez.delay;
      this.if_db_esterno = this.selez.db_esterno;
      this.messaggi_multipli = this.selez.multiple_messages;
      this.db_esterno = this.selez.id_database;
      this.ore_scelte = this.selez.orari_abilitati?this.selez.orari_abilitati.split(",").map(Number): this.selez.orari_abilitati;
      this.giorni_scelti = this.selez.giorni_abilitati?this.selez.giorni_abilitati.split(",").map(Number): this.selez.giorni_abilitati;
      this.festivita = this.selez.festivi_abilitati;
      let ora = this.selez.inizio?this.selez.inizio.split("T"): this.selez.inizio;
      this.ora_inizio = ora? ora[1]: null;
      this.id_gruppo = this.selez.id_gruppo;
      console.log("Ora inizio:" + this.ora_inizio);
      this.misura = this.selez.um_delay;
      if (this.selez.is_query == 1) {
        this.query_messaggio = "Query libera";
      } else {
        this.query_messaggio = "Testo";
        this.mex_testo = this.selez.query_messaggio;
      }
      console.log("Mounted");
    }
    this.gettabelle();
    this.getDatabase();
    this.getUnitaMisura();
  },
};
</script>
<style scoped>
</style>